import { formatPostalCode } from "@/Helpers/formatPostalCode";
import type { AddLocationLocationType } from "@/Shared/Types/locationTypes";
import type { SavedLocation } from "@freightsimple/generated-dashboard-openapi-client/models/SavedLocation";

/**
 * Where a location sits in the address book, matched on business name and
 * postal code — a location with no postal code never matches, since the two
 * blanks would otherwise look equal.
 */
export function bookShipmentFindSavedLocationIndex(
  location: AddLocationLocationType,
  savedLocations: Array<SavedLocation>,
) {
  return savedLocations.findIndex(function (sl) {
    return (
      sl.location.businessName === location.businessName &&
      location.address.postalCode &&
      formatPostalCode(sl.location.address.postalCode) ===
        formatPostalCode(location.address.postalCode)
    );
  });
}
